import { useHistory } from 'react-router-dom'

import { useResolveMagicLink } from '@scouts/auth'
import { addErrorToast, Loadable } from '@taxfix/scouts-ui'

import { PATH_ROOT } from '@/constants'

import { useCustomTokenFromMagicLink } from './hooks/use-custom-token-from-magic-link'

export const MagicLinkResolver = () => {
    const history = useHistory()

    const { customToken, redirectUrl, hasError } = useCustomTokenFromMagicLink()

    const onError = () => {
        addErrorToast({ body: 'Oops! There was a problem with the magic link...' })
        history.push(PATH_ROOT)
    }

    useResolveMagicLink({ customToken, redirectUrl, hasError, onError })

    return <Loadable isLoading />
}
